import { createGlobalStyle } from 'styled-components';
import { GlobalFontSizes } from './font-sizes';
import { BodyStyles } from './body-styles';
export const GlobalStyles = createGlobalStyle `
    /* ADD RULES TO NORMALIZE GLOBAL STYLES */
    html {
        ${BodyStyles}
        ${GlobalFontSizes}
    }
`;
//# sourceMappingURL=index.js.map